import PropTypes from 'prop-types'
import React from 'react'
import css from './SignupCompanyStep.module.css'
import t from 'tcomb-form'
import { space } from 'ui/variables'
import Space from 'ui/Space'
import Form from 'ui/Form'
import Button from 'ui/Button'
import { horizontalRadiosTemplate } from 'lib/tcomb-types'
import LoggedOutHeader from './LoggedOutHeader'
import CustomerQuote from './SignupCustomerQuote'

const RegularSchema = t.struct({
  company_name: t.String,
  company_size: t.enums({
    '1-5 employees': '1-5 employees',
    '5-10 employees': '5-10 employees',
    '10-50 employees': '10-50 employees',
    '50-100 employees': '50-100 employees',
    '100-1000 employees': '100-1000 employees',
    '1000+ employees': '1000+ employees'
  }),
  role: t.enums({
    founder: 'Founder',
    ceo: 'CEO',
    engineering: 'Engineering',
    research: 'Analyst',
    marketing: 'Marketing',
    product: 'Product',
    sales: 'Sales',
    customer_service: 'Customer Success',
    other: 'Other'
  })
})

const StrongLeadSchema = RegularSchema.extend({
  wants_help: t.enums({
    Yes: 'Yes',
    No: 'No'
  })
})

const formLayout = (locals) => (
  <div>
    {locals.inputs.company_name}

    {/* .form-group is from tcomb */}
    <div className={`form-group ${css.horizontalInputs}`}>
      <div className={css.horizontalInput}>{locals.inputs.company_size}</div>
      <div className={css.horizontalInput}>{locals.inputs.role}</div>
    </div>

    {locals.inputs.wants_help}
  </div>
)

const formOptions = {
  template: formLayout,
  fields: {
    company_name: {
      type: 'text',
      label: 'Company Name',
      error: 'Please enter your company name.',
      attrs: {
        placeholder: 'Company Inc.'
      }
    },
    company_size: {
      label: 'Company Size',
      nullOption: { value: '', text: 'Select a company size' },
      error: 'Please select your company size.'
    },
    role: {
      label: 'Your Role',
      nullOption: { value: '', text: 'Select a role' },
      error: 'Please select your role.'
    },
    wants_help: {
      factory: t.form.Radio,
      template: horizontalRadiosTemplate,
      label: 'Would you like help getting started?',
      error: 'Please select an option.'
    }
  }
}

const SignupCompanyStep = props => {
  const {
    formData,
    isDisabled,
    isLoading,
    onChange,
    onSubmit,
    isStrongLead
  } = props

  const schema = isStrongLead ? StrongLeadSchema : RegularSchema

  return (
    <div>
      <LoggedOutHeader title='Create your Segment account' />

      <Form
        schema={schema}
        options={formOptions}
        values={formData}
        onChange={onChange}
        onSubmit={onSubmit}>

        <Space value={space[4]} />

        <Button type='submit' extras='fluid' loading={isLoading} disabled={isDisabled}>
          Create your account
        </Button>
      </Form>

      <CustomerQuote role={formData.role} />
    </div>
  )
}

SignupCompanyStep.propTypes = {
  formData: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isStrongLead: PropTypes.bool
}

export default SignupCompanyStep



// WEBPACK FOOTER //
// ./components/SignupCompanyStep.js